import { ConfigOption } from '@ngx-formly/core';
import { FormlyAddressTransportRoutesComponent } from './components/address-transport-routes-widget/formly-address-transport-routes.component';

/** Formly types of the transport routes (registered in `custom-formly.config.ts`). */
export const TRANSPORT_ROUTE_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-address-transport-routes', component: FormlyAddressTransportRoutesComponent },
];
